var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{attrs:{"id":"map-static-card","flat":"","to":{ name: 'map', params: { parkinfo: _vm.parkinfo } }}},[_c('v-card-title',{staticClass:"justify-center"},[_c('img',{attrs:{"width":_vm.imageWidth,"height":_vm.imageHeight,"src":_vm.mapurl}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }